<template>
  <div id="index">
    <mHeader ref="mHeader"></mHeader> 
    <div style="width:100%;height:44px"></div>
    <!-- <div class="mSearch">
      <input placeholder="请输入内容" prefix-icon="el-icon-search" v-model="input2" />
      <img class="mHeaderLeft" src="../../assets/img/mLeft.png" >
      <button  @click="search">搜索</button>    
    </div> -->
    <div class="mIndex1">
      <div class="mIndex1Box">
        <div class="mIndex1Left">
          <ul>
            <li v-for="(item,index) in grouplist" :key="index" :class="activeClass == index ? 'indexProductActive':''"  v-trigger :id="'nav' + index" @click="showTwoProduct(item,index)" @mouseleave="hideTwoProduct(item,index)">
            <img :src="item.img" ref="imgSrc">{{item.name}}+
              <!-- <h6><img :src="item.img" >{{item.name}}+</h6> -->
              <!-- <p>
                <a v-for="item1 in item.alist" :key="item1.id" @click="goProductList(item1.id)">{{item1.varietiesName}}、</a>
              </p> -->
            </li>
          </ul>
          <div class="mIdex1LeftProduct" v-show="showProduct" v-for="(item,index) in twoGrouplist" :key="index"  @mouseenter="showTwoProductDiv(item)">
            <div class="">
              <h5><b @click="changeA(item,$event)">A</b><b @click="changeA(item,$event)">B</b><b @click="changeA(item,$event)">C</b><b @click="changeA(item,$event)">D</b><b @click="changeA(item,$event)">E</b><b @click="changeA(item,$event)">F</b></h5>
              <p><a v-for="item1 in item.alist" :key="item1.id" :class="item1.firstLetter == onA ? 'index1LeftProductP':''" @click="goProductList(item1.id)">{{item1.varietiesName}}、</a></p>
            </div>
            <div class="">
              <h5><b @click="changeA(item,$event)">G</b><b @click="changeA(item,$event)">H</b><b @click="changeA(item,$event)">I</b><b @click="changeA(item,$event)">J</b><b @click="changeA(item,$event)">K</b><b @click="changeA(item,$event)">L</b></h5>
              <p><a v-for="item1 in item.blist" :key="item1.id" :class="item1.firstLetter == onA ? 'index1LeftProductP':''"  @click="goProductList(item1.id)">{{item1.varietiesName}}、</a></p>
            </div>
            <div class="">
              <h5><b @click="changeA(item,$event)">M</b><b @click="changeA(item,$event)">N</b><b @click="changeA(item,$event)">O</b><b @click="changeA(item,$event)">P</b><b @click="changeA(item,$event)">Q</b><b @click="changeA(item,$event)">R</b><b @click="changeA(item,$event)">S</b></h5>
              <p><a v-for="item1 in item.clist" :key="item1.id" :class="item1.firstLetter == onA ? 'index1LeftProductP':''" @click="goProductList(item1.id)">{{item1.varietiesName}}、</a></p>
            </div>
            <div class="">
              <h5><b @click="changeA(item,$event)">T</b><b @click="changeA(item,$event)">U</b><b @click="changeA(item,$event)">V</b><b @click="changeA(item,$event)">W</b><b @click="changeA(item,$event)">X</b><b @click="changeA(item,$event)">Y</b><b @click="changeA(item,$event)">Z</b></h5>
              <p><a v-for="item1 in item.dlist" :key="item1.id" :class="item1.firstLetter == onA ? 'index1LeftProductP':''"  @click="goProductList(item1.id)">{{item1.varietiesName}}、</a></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import mHeader from '../../components/mobile/mHeader'
export default {
  components: {
    mHeader
  },
  data() {
     return {
      input2:'',
      isDialog:false,
      searchText:'',
      searchDiv:false,
      searchList:[],
      showLogin:true,
      showAfterLogin:false,
      grouplist:[],//分类
      twoGrouplist:[],//二级分类
      showProduct:true,
      indexDiv:true,
      onA:'',
    }
  },
  mounted() {
    this.activeClass = this.$cookie.get('navIndex')
    if(this.$cookie.get('account') == null){
      this.showLogin = true
      this.showAfterLogin = false
    }else{
      this.showLogin = false
      this.showAfterLogin = true
    }
    this.getGroupList();
  },
  directives:{
    trigger:{
     inserted(el, binging){
        el.id == 'nav0' ? el.click() : null // 只点击第一个，id是在循环中手动添加的
       // $(el).trigger('click')  // 所有都触发一次,然后就是最后一个jquery方法
      }
    }
  },
  methods: {
    //分类
    getGroupList(){
      this.$fetch('getGroupList').then(res => {
        this.grouplist = res.result;
      })
    },
    // 点击显示二级药材
    showTwoProduct(data,index){
        this.showProduct = true;
        this.$refs.imgSrc[index].src = this.grouplist[index].checkImg
        this.twoGrouplist = [JSON.parse(JSON.stringify(data))];
        this.activeClass = index
    },
    hideTwoProduct(data,index){
      this.showProduct = false;
      this.$refs.imgSrc[index].src = this.grouplist[index].img
      this.onA = ''
    },
    showTwoProductDiv(){
      this.showProduct = true
    },
    // 首字母选择
    changeA(data,event){
      if(event.target.innerText == 'A' || event.target.innerText == 'B' || event.target.innerText == 'C' || event.target.innerText == 'D' || event.target.innerText == 'F' ){
        for(var i=0;i<data.alist.length;i++){
          if(data.alist[i].firstLetter == event.target.innerText){
            this.onA = event.target.innerText
          }
        }
      }
      if(event.target.innerText == 'G' || event.target.innerText == 'H' || event.target.innerText == 'I' || event.target.innerText == 'J' || event.target.innerText == 'K' || event.target.innerText == 'L' ){
        for(var i=0;i<data.blist.length;i++){
          if(data.blist[i].firstLetter == event.target.innerText){
            this.onA = event.target.innerText
          }
        }
      }
      if(event.target.innerText == 'M' || event.target.innerText == 'N' || event.target.innerText == 'O' || event.target.innerText == 'P' || event.target.innerText == 'Q' || event.target.innerText == 'R' || event.target.innerText == 'S'){
        for(var i=0;i<data.clist.length;i++){
          if(data.clist[i].firstLetter == event.target.innerText){
            this.onA = event.target.innerText
          }
        }
      }
      if(event.target.innerText == 'T' || event.target.innerText == 'U' || event.target.innerText == 'V' || event.target.innerText == 'W' || event.target.innerText == 'X' || event.target.innerText == 'Y' || event.target.innerText == 'Z'){
        for(var i=0;i<data.dlist.length;i++){
          if(data.dlist[i].firstLetter == event.target.innerText){
            this.onA = event.target.innerText
          }
        }
      }
    },
    goProductList(id){
      if(id != '' || id != null){
        this.$router.push({name:'mProductList',query: {groupId:id}})
      }else{
        this.$router.push('/mProductList')
      }
    },
    isClose(){
      this.isDialog = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/mobile/mClassList.vue